module.exports = __webpack_public_path__ + "img/01_content_02.b9cb978d.png";